import { ChainId, GASTANK_DEPLOYMENTS } from '@shared/utils/config/networks';
import { buildPermit2Details } from '@shared/utils/evm/buildBatchTransferDetails';
export default async function buildAllPermit2Details({
  tokensToApprove,
  ethersPKPWallet
}) {
  try {
    const fromAssetsByNetwork = [];
    tokensToApprove.forEach(asset => {
      const arrayExists = fromAssetsByNetwork.find(x => x[0].network === asset.network);
      if (arrayExists) {
        arrayExists.push(asset);
      } else {
        fromAssetsByNetwork.push([asset]);
      }
    });
    const solanaIndex = fromAssetsByNetwork.findIndex(x => (x === null || x === void 0 ? void 0 : x[0].network) === ChainId.SOLANA);
    // If solanaIndex remove so we can add it at the end
    // let solanaArray = [];
    // if (solanaIndex >= 0) {
    //   solanaArray = fromAssetsByNetwork.splice(solanaIndex, 1);
    // }
    const batchesAndSigs = await Promise.all(fromAssetsByNetwork.map(async assets => {
      const network = assets[0].network;
      const gasTank = GASTANK_DEPLOYMENTS[network];
      const tokensIn = assets.map(x => x.contract_address);
      const amounts = assets.map(x => {
        return x.amountToApprove;
      });
      const result = await buildPermit2Details({
        tokensIn,
        amounts,
        spender: gasTank,
        network,
        ownerAccount: ethersPKPWallet
      });
      return result;
    }));
    const permitBatchDetails = batchesAndSigs.map(x => x.permitBatchDetails);
    const permitSignatures = batchesAndSigs.map(x => x.permitSignature);
    if (solanaIndex >= 0) {
      permitBatchDetails.splice(solanaIndex, 0, null);
      permitSignatures.splice(solanaIndex, 0, null);
    }
    return {
      permitBatchDetails,
      permitSignatures
    };
  } catch (e) {
    console.error('[buildAllPermit2Details]', e, ethersPKPWallet);
    return {
      permitBatchDetails: [],
      permitSignatures: []
    };
  }
}